import DataSelectionModel from "./DataSelectionModal";
import * as yup from "yup";
import Form from "react-bootstrap/Form";
import { WfsGetFeatureRequest } from "../../types/Wfs/WfsGetFeatureRequest";
import { useDataSelectionContext } from "./DataSelectionContext";
import { useMemo } from "react";

interface OsmRoadsFormValues {
  outputFormat: string;
}

const OsmRoads = () => {
  const layerName = "osm:roads";
  const { layers, getLayer, wfsOrder } = useDataSelectionContext();
  const layer = useMemo(() => getLayer(layerName), [layers]);
  const initialValues = useMemo(
    () =>
      ({
        outputFormat: "osm",
      } as OsmRoadsFormValues),
    [layer],
  );
  const schema = useMemo(
    () =>
      yup.object({
        outputFormat: yup.string().oneOf(["osm", "gml"]).required(),
      }),
    [layer],
  );

  const onSubmit = (values: OsmRoadsFormValues) => {
    wfsOrder({
      service: "WFS",
      version: "2.0.0",
      request: "GetFeature",
      resultType: "Results",
      typeNames: layerName,
      outputFormat: values.outputFormat,
    } as WfsGetFeatureRequest);
  };

  return (
    <DataSelectionModel
      headerText="OSM Roads"
      layer={layer}
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}>
      {({ values, handleChange, handleBlur }) => (
        <>
          <Form.Group>
            <Form.Label htmlFor="outputFormat">Format</Form.Label>
            <Form.Select
              id="outputFormat"
              name="outputFormat"
              value={values.outputFormat}
              onChange={handleChange}
              onBlur={handleBlur}>
              <option value="gml">GML 3</option>
              <option value="osm">OSM</option>
            </Form.Select>
          </Form.Group>
        </>
      )}
    </DataSelectionModel>
  );
};

export default OsmRoads;
